module.exports = __webpack_public_path__ + "img/bg.6e0c5f0d.png";